import React, { useEffect, useState } from 'react';
import Alert from '../../../layouts/Alert';
import _ from 'underscore';

import FloorListItem from './FloorListItem';
import Search from '../../../layouts/Search';
import SortIcon from '../../../layouts/SortIcon';
import FloorFilter from './FloorFilter';
import Pagination from '../../../layouts/Pagination';

const FloorsList = ({ floorsList, floorListLoading }) => {
  const [listSearch, setListSearch] = useState(floorsList);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [icons, setIcons] = useState({
    floor: 0,
    buiding_name: 0,
  });

  const { floor, buiding_name } = icons;

  useEffect(() => {
    if (!floorListLoading) {
      setListSearch(floorsList);
    }
  }, [floorListLoading, setListSearch, floorsList]);

  return (
    <div className='card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 admin-list h-100'>
      <Alert />
      <div className='d-flex w-100 align-items-center justify-content-between mb-3'>
        <div className=''>
          {!floorListLoading && listSearch.length / 7 > 1 && (
            <Pagination
              listSearch={listSearch}
              setPage={setPage}
              size={7}
              page={page}
            />
          )}
        </div>
        <div className='d-flex'>
          <Search
            setListSearch={setListSearch}
            filter={(e) => {
              const list = floorsList.filter(
                (item) =>
                  item.floor
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()) ||
                  item.building_name
                    .toUpperCase()
                    .includes(e.target.value.toUpperCase()),
              );
              return list;
            }}
            setSearch={setSearch}
          />
        </div>
      </div>
      <div className='row m-0 rounded admin-list-header txt-primary p-2 w-100'>
        <div
          className='admin-list-fields col p-0 text-truncate '
          onClick={() => {
            if (floor === 0) {
              setListSearch(_.sortBy(listSearch, 'floor'));
              setIcons({
                floor: 1,
                buiding_name: 0,
              });
            } else if (floor === 1) {
              let l = _.sortBy(listSearch, 'floor');
              setListSearch(l.reverse());
              setIcons({
                floor: -1,
                buiding_name: 0,
              });
            } else {
              setListSearch(floorsList);
              setIcons({
                floor: 0,
                buiding_name: 0,
              });
            }
          }}
        >
          Name
          <SortIcon icon={floor} />
        </div>
        <div
          className='admin-list-fields col p-0 text-truncate '
          onClick={() => {
            if (buiding_name === 0) {
              setListSearch(_.sortBy(listSearch, 'buiding_name'));
              setIcons({
                buiding_name: 1,
                floor: 0,
              });
            } else if (buiding_name === 1) {
              let l = _.sortBy(listSearch, 'buiding_name');
              setListSearch(l.reverse());
              setIcons({
                buiding_name: -1,
                floor: 0,
              });
            } else {
              setListSearch(floorsList);
              setIcons({
                buiding_name: 0,
                floor: 0,
              });
            }
          }}
        >
          Building
          <SortIcon icon={buiding_name} />
        </div>

        <div className='admin-list-fields col p-0 text-truncate text-center'>
          Actions
        </div>
      </div>
      <div className='admin-list-body '>
        {floorListLoading ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          listSearch
            .slice(7 * (page - 1), 7 * page)
            .map((floor, id) => <FloorListItem floor={floor} key={id} />)
        )}
      </div>
    </div>
  );
};

export default FloorsList;
